import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigService } from '../config/config.service';

@Injectable()
export class ApiRootInterceptorService implements HttpInterceptor {
    constructor(private configService: ConfigService) {
    }

    // If the request is "relative" to the apiRoot then prepend the apiRoot.
    // See: https://stackoverflow.com/questions/45735655/how-to-setup-baseurl-for-angular-httpclient
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.url.startsWith('http://') || request.url.startsWith('https://')) {
            return next.handle(request);
        } else {
            return next.handle(request.clone({
                url: `${this.configService.config.apiRoot}${request.url}`
            }));
        }
    }
}
